import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function Settings() {
  const { api } = useAuth();
  const toast = useToast();
  const [tab, setTab] = useState('keys');

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>⚙️ الإعدادات</h2>

      <div style={{ display: 'flex', gap: 4, marginBottom: 16, borderBottom: '1px solid var(--border)' }}>
        {[
          { k: 'keys',     label: '🔑 مفاتيح Groq' },
          { k: 'glossary', label: '📚 قاموس المصطلحات' },
          { k: 'youtube',  label: '▶️ YouTube API' },
          { k: 'log',      label: '📜 سجلّ النظام' },
        ].map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} style={{
            padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer',
            borderBottom: tab === t.k ? '2px solid var(--primary)' : '2px solid transparent',
            color: tab === t.k ? 'var(--primary)' : 'var(--text-muted)', fontWeight: tab === t.k ? 600 : 400,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'keys'     && <GroqKeysTab api={api} toast={toast} />}
      {tab === 'glossary' && <GlossaryTab  api={api} toast={toast} />}
      {tab === 'youtube'  && <YoutubeTab   api={api} toast={toast} />}
      {tab === 'log'      && <LogTab       api={api} />}
    </div>
  );
}

function GroqKeysTab({ api, toast }) {
  const [keys, setKeys] = useState([]);
  const [newKey, setNewKey] = useState('');
  const [adding, setAdding] = useState(false);

  const load = () => api('/settings/transcription/keys').then(r => setKeys(r.keys || [])).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const add = async () => {
    if (newKey.length < 10) return;
    setAdding(true);
    try { await api('/settings/transcription/keys', { method: 'POST', body: JSON.stringify({ api_key: newKey }) }); setNewKey(''); load(); toast.success('تمت الإضافة'); }
    catch (e) { toast.error(e.message); }
    setAdding(false);
  };

  const remove = async (idx) => {
    if (!window.confirm('حذف هذا المفتاح؟')) return;
    try { await api(`/settings/transcription/keys/${idx}`, { method: 'DELETE' }); load(); }
    catch (e) { toast.error(e.message); }
  };

  const test = async () => {
    try {
      const r = await api('/settings/transcription/test', { method: 'POST' });
      r.ok ? toast.success(r.message) : toast.error(r.error);
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div className="card">
      <div className="card-title" style={{ marginBottom: 12 }}>مفاتيح Groq API ({keys.length})</div>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
        كلّ مفتاح من حساب Groq مستقل = حصّة ساعيّة منفصلة (ساعتان من الصوت/ساعة لكل واحد). أضف عدّة مفاتيح لمعالجة ملفّات أطول دون انتظار.
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input className="form-input" placeholder="gsk_..." value={newKey} onChange={e => setNewKey(e.target.value)} dir="ltr" style={{ flex: 1 }}/>
        <button className="btn btn-primary" onClick={add} disabled={adding || newKey.length < 10}>+ إضافة مفتاح</button>
      </div>
      {keys.length === 0 ? (
        <div className="empty">لا مفاتيح. أضف واحداً للبدء.</div>
      ) : keys.map((k, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, background: 'var(--gray-50)', borderRadius: 6, marginBottom: 8 }}>
          <span style={{ fontFamily: 'monospace', direction: 'ltr' }}>{k}</span>
          <button className="btn btn-sm btn-outline" style={{ color: 'var(--danger)' }} onClick={() => remove(i)}>🗑️</button>
        </div>
      ))}
      {keys.length > 0 && (<button className="btn btn-outline" onClick={test} style={{ marginTop: 12 }}>اختبار الاتصال بـ Groq</button>)}
    </div>
  );
}

function GlossaryTab({ api, toast }) {
  const [items, setItems] = useState([]);
  const load = () => api('/settings/glossary').then(r => setItems(r.items || [])).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  const save = async () => {
    try { await api('/settings/glossary', { method: 'PUT', body: JSON.stringify({ items: items.filter(i => i.term?.trim()) }) }); toast.success('تم الحفظ'); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <div className="card">
      <div className="card-title" style={{ marginBottom: 12 }}>قاموس المصطلحات</div>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>الكلمات هنا تُحقن في تعليمات النموذج.</div>
      {items.map((it, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 8, marginBottom: 8 }}>
          <input className="form-input" placeholder="المصطلح" value={it.term || ''} onChange={e => { const c = [...items]; c[i].term = e.target.value; setItems(c); }}/>
          <input className="form-input" placeholder="ملاحظة (اختياري)" value={it.note || ''} onChange={e => { const c = [...items]; c[i].note = e.target.value; setItems(c); }}/>
          <button className="btn btn-outline" onClick={() => setItems(items.filter((_, idx) => idx !== i))}>🗑️</button>
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button className="btn btn-outline" onClick={() => setItems([...items, { term: '', note: '' }])}>+ مصطلح</button>
        <button className="btn btn-primary" onClick={save}>حفظ</button>
      </div>
    </div>
  );
}

function YoutubeTab({ api, toast }) {
  const [url, setUrl] = useState('');
  const [source, setSource] = useState('');
  const load = () => api('/settings/youtube-api').then(r => { setUrl(r.url || ''); setSource(r.source); }).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  const save = async () => {
    try { await api('/settings/youtube-api', { method: 'PUT', body: JSON.stringify({ url }) }); toast.success('تم الحفظ'); load(); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <div className="card">
      <div className="card-title" style={{ marginBottom: 12 }}>رابط Cobalt API</div>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>افتراضياً: <code>https://api.cobalt.tools/</code></div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input className="form-input" value={url} onChange={e => setUrl(e.target.value)} dir="ltr" style={{ flex: 1 }}/>
        <button className="btn btn-primary" onClick={save}>حفظ</button>
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>المصدر الحالي: {source || '—'}</div>
    </div>
  );
}

function LogTab({ api }) {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState('');
  const load = () => {
    const qs = filter ? `?contains=${encodeURIComponent(filter)}` : '';
    api(`/settings/log${qs}`).then(r => setEntries(r.entries || [])).catch(() => {});
  };
  useEffect(() => { load(); }, []); // eslint-disable-line
  return (
    <div className="card">
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input className="form-input" placeholder="فلترة" value={filter} onChange={e => setFilter(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()}/>
        <button className="btn btn-outline" onClick={load}>🔄 تحديث</button>
      </div>
      <div style={{ maxHeight: 600, overflow: 'auto', fontFamily: 'monospace', fontSize: 12, direction: 'ltr', textAlign: 'left' }}>
        {entries.length === 0 ? <div className="empty">لا أحداث</div> : entries.map((e, i) => (
          <pre key={i} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: '0 0 12px', padding: 8, background: 'var(--gray-50)', borderRadius: 4 }}>{e}</pre>
        ))}
      </div>
    </div>
  );
}
